import { createPortal } from "react-dom";

export const Portal = ({ components, node }) => (
    <>
      {createPortal(components, node)}
    </>
);
